import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAr = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 48 48" {...props}>
        <path
            d="M7 4a1 1 0 011 1v35h35a1 1 0 011 1v2a1 1 0 01-1 1H4V5a1 1 0 011-1h2zm35.727 4.633A1 1 0 0143 9.32V36a1 1 0 01-1 1H12a1 1 0 01-1-1V23l11.324-10.38a1 1 0 011.352 0l6.787 6.22 10.85-10.247a1 1 0 011.414.04zM39 16.28l-8.497 8.024L23 17.426l-8 7.334V33h24V16.28z"
            style={{
                fill: 'currentColor',
                fillRule: 'evenodd',
            }}
        />
    </svg>
);
export default SvgAr;
